// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });

    gsap.registerPlugin(ScrollTrigger);

    const counter = document.querySelectorAll('.count');
    if (counter) {
      counter.forEach(el => {
        const end = parseFloat(el.dataset.end) || 0;
        const proxy = { val: 0 };

        gsap.to(proxy, {
          val: end,
          duration: 2,
          ease: "power2.out",
          onUpdate: () => {
            el.textContent = Math.round(proxy.val).toLocaleString('pt-BR');
          },
          scrollTrigger: {
            trigger: el,
            start: "top 90%",   // quando o elemento chegar a 80% da viewport
            /*toggleActions: "play none none none", */
            toggleActions: "play none none reverse",
            //once: true          // roda só uma vez
          }
        });
      });     
    }


    const typingEl = document.querySelectorAll(".-typing");
    if (typingEl.length > 0) {
      gsap.utils.toArray(".-typing").forEach((text) => {
        //let text = document.querySelector(".-typing");
        let content = text.textContent;
        text.textContent = ""; // clear first
        gsap.to(text, {
          duration: 2.5,
          text: content,  // Requires TextPlugin
          ease: "none"
        });
      });
    }
    // Fade-in sections on scroll
    gsap.utils.toArray(".-fade-in").forEach((secfade) => {
      gsap.from(secfade, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: secfade,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    });

    gsap.utils.toArray(".-animate-in").forEach((sec) => {
      /*gsap.to(sec, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "none",
        //ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });*/
      gsap.from(sec, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none "
        }
      });
    });

    const slides = document.querySelectorAll('.-hg-main-slide');
    let currentIndex = 0;
    const slideInterval = 5000; // 5 seconds per slide

    function nextSlide() {
      // Remove active class from the current slide
      slides[currentIndex].classList.remove('active');
      
      // Calculate the next index (looping back to 0 at the end)
      currentIndex = (currentIndex + 1) % slides.length;
      
      // Add active class to the new slide
      slides[currentIndex].classList.add('active');
    }

    if (slides.length) {
      // Start the auto-timer
      setInterval(nextSlide, slideInterval);   
    } 

    /*read more*/
    var readMoreTrigger = document.getElementsByClassName("-rm-trigger");
    
    var toggleMoreContent = function() {
        var excerpt = this.parentNode.getElementsByClassName('-rm-excerpt')[0];
        var moreText = this.parentNode.getElementsByClassName('-rm-more')[0];

        if (excerpt.style.display === "none") {
          excerpt.style.display = "block";
          moreText.style.display = "none";
          this.innerHTML = "Ver mais";
        } else {
          excerpt.style.display = "none";
          moreText.style.display = "block";
          this.innerHTML = "Ver menos";
        }
    };

    for (var i = 0; i < readMoreTrigger.length; i++) {
        readMoreTrigger[i].addEventListener('click', toggleMoreContent, false);
    }     
    
    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    //Search trigger
    var searchTrigger = document.getElementsByClassName("search-trigger-btn");
    
    var toggleSearch = function() {
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("search-active");
    };

    for (var i = 0; i < searchTrigger.length; i++) {
        searchTrigger[i].addEventListener('click', toggleSearch, false);
    }

    //modal trigger
    var modalTrigger = document.getElementsByClassName("modal-trigger-btn");
    
    var toggleModal = function() {
        event.preventDefault();
        const modal = this.dataset.modal;
        if (modal) {
          document.getElementById(modal).classList.add('-modal-active');
        }
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("modal-active");
    };

    for (var i = 0; i < modalTrigger.length; i++) {
        modalTrigger[i].addEventListener('click', toggleModal, false);
    }

    //modal close
    var modalClose = document.getElementsByClassName("modal-close-btn");
    
    var closeModal = function() {
        event.preventDefault();
        const modals = document.querySelectorAll('.-modal');
        modals.forEach(element => {
          element.classList.remove('-modal-active');
        });
        const formModals = document.querySelectorAll('.-modal-form');
        formModals.forEach(element => {
          element.classList.remove('-active');
        });
        document.body.classList.remove("modal-active");
    };

    for (var i = 0; i < modalClose.length; i++) {
        modalClose[i].addEventListener('click', closeModal, false);
    }     
    
    

    function redirect(goto){
        /*var conf = confirm("Are you sure you want to go elswhere?");
        if (conf && goto != '') {
            window.location = goto;
        }*/
        window.location = goto;
    }
   
    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href"); 
      const offsetTop = document.querySelector(href).offsetTop;
     
      scroll({
        top: offsetTop-header,
        /*top: offsetTop,*/
        behavior: "smooth"
      });
    }

    /*Anchor scroll nav*/
    const anchorsNav = document.querySelectorAll(".scroller > a");
     
    for (const anchorNav of anchorsNav) {
      anchorNav.addEventListener("click", clickHandlerNav);
    }
     
    function clickHandlerNav(e) {
      e.preventDefault();
      let header = document.querySelector("header").offsetHeight;
      let href = this.getAttribute("href"); 
      let split = href.split('#');
      let anchor = '#'+split[1];
      let offsetTop = document.querySelector(anchor).offsetTop;
      if (document.querySelector("header").classList.contains('-sticky')) {
        
      }else{
        header = header-20;
      }
      
      document.body.classList.remove("menu-active");
      
     
      scroll({
        top: offsetTop-header,
        /*top: offsetTop,*/
        behavior: "smooth"
      });
    }


    /*nav tabs*/
    $('.nav-tab-btn').click(function(){
        event.preventDefault();
        var tabTarget = $(this).data('tab');
        console.log(tabTarget);
        $(this).closest('.tabs-wrap').find('.tabs-content').removeClass('-visible');
        $(this).closest('.tabs-wrap').find('.tabs-content#'+tabTarget).addClass('-visible');
        $(this).closest('.tabs-wrap').find('.nav-tab-btn').removeClass('active');
        $(this).addClass('active');
    });    


    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            if (parent) {
              parent.find('.-accordion-item').removeClass('-active');
            }
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            if (parent) {
              parent.find('.-accordion-item').removeClass('-active');
            }
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });         
      

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      
      if ($(window).width() < 1025) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }
    });

    //Calculator
    const slider = document.getElementById('rangeSlider');
    const sliderValueText = document.getElementById('sliderValue');
    const box1 = document.getElementById('price-val');
    const rangeBase = document.getElementById('range-base');

    function customRound(value) {
        const decimalPart = value % 1;
        return decimalPart >= 0.5 ? Math.ceil(value) : Math.floor(value);
    }


    function updateTrackFill() {
        const min = slider.min ? parseInt(slider.min) : 1;
        const max = slider.max ? parseInt(slider.max) : 5000;
        const val = parseInt(slider.value);
        
        // Calculate percentage position of the slider
        const percentage = ((val - min) / (max - min)) * 100;
        
        // Pass this percentage straight to the CSS variable
        slider.style.setProperty('--value-percent', percentage + '%');
    }

    function calcularCOV(salario, dias, Impacto ) {
        const fatorImpacto = parseFloat(Impacto) || 1.5;

        const DIAS_UTEIS_MES = 22;
        const custoDiarioBase = salario / DIAS_UTEIS_MES;
        const perdaDiariaReal = custoDiarioBase * fatorImpacto;
        const custoTotalAcumulado = perdaDiariaReal * dias;

          // Atualiza os labels e valores na tela
          //spanDiasLabel.textContent = dias;
          //return custoDiarioBase.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          ///return  perdaDiariaReal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          /*console.log(custoTotalAcumulado);*/
          return custoTotalAcumulado.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
          /*return custoTotalAcumulado;*/
    }

    function updateBoxes() {
        const currentDays = parseInt(slider.value);
        const currentBaseSalary = parseInt(rangeBase.value);

        //console.log(currentDays+' - '+currentBaseSalary);
        
        sliderValueText.textContent = currentDays.toLocaleString();

        /*checkActiveButton(currentVal);*/
        updateTrackFill();

        const cost = calcularCOV(currentBaseSalary, currentDays, 2);
        console.log(cost);
        box1.textContent = cost;
        
    }

    if (slider) {

        rangeBase.addEventListener('input', updateBoxes);
        slider.addEventListener('input', updateBoxes);

        updateBoxes();
    }    

    

   

/*form file*/
const formFileField = document.querySelectorAll('.custom-file-field');
const formFileFieldClear = document.getElementById('file-clear');
if (formFileField) {

  formFileField.forEach(fileField => {
      fileField.addEventListener('change', function() {
        var fileName = fileField.files[0] ? fileField.files[0].name : "Nenhum arquivo...";
        document.getElementById('file-upload-label').classList.add('hide')
        document.getElementById('file-info').classList.remove('hide')
        document.getElementById('file-info').classList.add('selected')
        document.getElementById('file-name-display').textContent = fileName;
        if (fileField.files[0]) {
            var file = fileField.files[0];
            var fileSize = formatBytes(file.size);
            document.getElementById('file-size-display').textContent = fileSize;
        }

      });
  });
}
if (formFileFieldClear) {
  formFileFieldClear.addEventListener('click', function() {
    console.log('clear trrigg')
      const groupFieldFile = this.closest('.-form-file-upload');
      const fileInput = groupFieldFile.querySelector('.custom-file-field');
      /*const nameDisplay = document.getElementById('nome-do-arquivo');
      const btnLimpar = document.getElementById('btn-limpar');*/

      fileInput.value = ""; // Limpa o arquivo no input real
      document.getElementById('file-upload-label').classList.remove('hide')
      document.getElementById('file-info').classList.add('hide')
      document.getElementById('file-info').classList.remove('selected')
  });
}


function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}



    /*Input Masks*/
    function runmask() {
      v_obj.value=v_fun(v_obj.value);
    }

    function mask(o,f) {
      v_obj=o;
      v_fun=f;
      setTimeout(runmask(),1)
    }

    function mtel(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
      v = v.replace(/(\d)(\d{4})$/, "$1-$2");
      return v;
    }

    function modate(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "$1/$2");
      v = v.replace(/(\d)(\d{3})$/, "$1/$2");
      return v;
    }

    function mnumbers(v) {
      v = v.replace(/\D/g, "");
      return v;
    }
    function mcep(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{5})(\d)/g, "$1-$2");
      return v;
    }
    function price(v) {
        /*v = v.replace(/\D/g, "");
        v = v.replace(/([0-9]{2})$/g, ",$1");
        v = v.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        v = v.replace(/([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2,$3");
        v = v.replace(/([0-9]{3}).([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2.$3,$4");
        return v;*/
        v = v + '';
        v = parseInt(v.replace(/[\D]+/g, ''));
        v = v + '';
        v = v.replace(/([0-9]{2})$/g, ",$1");

        if (v.length > 6) {
            v = v.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        }

        if(v == 'NaN') v = '';
        return v;
    }

    function mCpf(v){
      //Remove tudo o que não é dígito
      v=v.replace(/\D/g,"")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{3})(\d)/,"$1.$2")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v=v.replace(/(\d{3})(\d)/,"$1.$2")

      //Coloca um hífen entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")

      return v  
    }

    function cpfCnpj(v){
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g,"");
     
        if (v.length < 14) { //CPF   405.604.628-08  43.201.151/0001-99
     
            //Coloca um ponto entre o terceiro e o quarto dígitos
            v=v.replace(/(\d{3})(\d)/,"$1.$2")
     
            //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            v=v.replace(/(\d{3})(\d)/,"$1.$2")
     
            //Coloca um hífen entre o terceiro e o quarto dígitos
            v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
     
        } else { //CNPJ
            //console.log('aki');
            //Coloca ponto entre o segundo e o terceiro dígitos
            v=v.replace(/^(\d{2})(\d)/,"$1.$2")
     
            //Coloca ponto entre o quinto e o sexto dígitos
            v=v.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")
     
            //Coloca uma barra entre o oitavo e o nono dígitos
            v=v.replace(/\.(\d{3})(\d)/,".$1/$2")
     
            //Coloca um hífen depois do bloco de quatro dígitos
            v=v.replace(/(\d{4})(\d)/,"$1-$2")
     
        }
     
        return v
     
    }

    var cepValidator = document.getElementsByClassName('mask-cep');
    var cpfValidator = document.getElementsByClassName('mask-cpf');
    var telValidator = document.getElementsByClassName('mask-tel');
    var dateValidator = document.getElementsByClassName('mask-date');
    var priceValidator = document.getElementsByClassName('mask-price');
    var documentValidator = document.getElementsByClassName('mask-doc');
    var numberValidator = document.getElementsByClassName('mask-num');
   

    if(cepValidator && cepValidator.length != -1){
      for (i = 0; i < cepValidator.length; i++) {
        cepValidator[i].addEventListener('keydown', function() {
          mask(this, mcep);
        });
      }
    }
    if(cpfValidator && cpfValidator.length != -1){
      for (i = 0; i < cpfValidator.length; i++) {
        cpfValidator[i].addEventListener('keydown', function() {
          mask(this, mCpf);
        });
      }
    }
    if(telValidator && telValidator.length != -1){
      for (i = 0; i < telValidator.length; i++) {
        telValidator[i].addEventListener('keydown', function() {
          mask(this, mtel);
        });
      }
    }
    if(dateValidator && dateValidator.length != -1){
      for (i = 0; i < dateValidator.length; i++) {
        dateValidator[i].addEventListener('keydown', function() {
          mask(this, modate);
        });
      }
    }
    if(numberValidator && numberValidator.length != -1){
      for (i = 0; i < numberValidator.length; i++) {
        numberValidator[i].addEventListener('keydown', function() {
          mask(this, mnumbers);
        });
      }
    }

    if(priceValidator && priceValidator.length != -1){
      for (i = 0; i < priceValidator.length; i++) {
        priceValidator[i].addEventListener('keyup', function() {
          mask(this, price);
        });
      }
    }

    if(documentValidator && documentValidator.length != -1){
      for (i = 0; i < documentValidator.length; i++) {
        documentValidator[i].addEventListener('keydown', function() {
          mask(this, cpfCnpj);
        });
      }
    }

    /*CEP autocomplete*/
    $(".cep-autocomplete").blur(function(){
        var address = $(this).closest('form').find(".endereco");
        var number = $(this).closest('form').find(".numero");
        var neighborhood = $(this).closest('form').find(".bairro");
        var city = $(this).closest('form').find(".cidade");
        var state = $(this).closest('form').find(".estado");
        var cep = this.value.replace(/[^0-9]/, "");
        if(cep.length != 8){
            return false;
        }        
        var url = "https://viacep.com.br/ws/"+cep+"/json/";
        $.getJSON(url, function(dadosRetorno){ /*console.log(dadosRetorno);*/
            try{
                address.val(dadosRetorno.logradouro);
                neighborhood.val(dadosRetorno.bairro);
                city.val(dadosRetorno.localidade);
                state.val(dadosRetorno.uf);
                number.focus();
            }catch(ex){}
        });
    });                

     /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) { 
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('sonolayer_cookie_lgpd_consent');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('sonolayer_cookie_lgpd_consent', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('sonolayer_cookie_lgpd_consent', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('sonolayer_cookie_lgpd_consent', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    }); 

}(window.jQuery, window, document));